import { DPF_GET_TYPE_DEPOSITS } from './../constants';
import { handleActions } from "redux-actions"

export const complements  = handleActions(
  {
    [ DPF_GET_TYPE_DEPOSITS ]: (state, action) => {
      return { ...state, dpfTypesDeposits: action.payload.data }
    }
  }, {}
)